module.exports = __webpack_public_path__ + "img/215_216_217_218.227a168a.png";